/**
 * @param {*} filePath
 * @param {*} fileUrl
 * @returns {GumDO | null}
 */

export const getGumDOFromFilePath = async (filePath, fileUrl) => {
  const regex = /.*_STAGE_(\d+).*__(LOWER|UPPER)__GUM.(?!raw$)([^\s.]+)$/i;
  const match = filePath.match(regex);
  if (match) {
    const stageNumber = parseInt(match[1], 10);
    const toothGumType = match[2];
    const fileType = match[3];

    return {
      stageNumber,
      toothGumType,
      fileUrl,
      fileType,
      filePath,
    }
  }
  return null;
};
